import React from 'react';
import { Flex } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';

const StyledHr = styled.hr`
  border: none;
  border-top: 1px dashed ${getColor('botticelli')};
  background-color: transparent;
  width: 80%;
  padding-top: 1rem;
`;

const GroupWidgetNotEnoghData = () => {
  return (
    <Flex height='8rem' direction='column' items='center' justify='center'>
      <StyledHr />
      <Flex>
        <Text color='botticelli' mr='0.3rem'>
          NOT ENOUGH DATA
        </Text>
        <Icon name='muierroroutline' color='botticelli' />
      </Flex>
    </Flex>
  );
};

export default GroupWidgetNotEnoghData;
